import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enErrors from '../locales/en/errors.json';
import enRegistration from '../locales/en/registration.json';
import frCommon from '../locales/fr/common.json';
import frErrors from '../locales/fr/errors.json';
import frRegistration from '../locales/fr/registration.json';

const resources = {
  en: {
    common: enCommon,
    errors: enErrors,
    registration: enRegistration,
  },
  fr: {
    common: frCommon,
    errors: frErrors,
    registration: frRegistration,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'errors', 'registration'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18n_language',
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: true,
    },

    debug: false, // Set to true for development debugging
  });

export default i18n;
